var poll_default = {
  "fontElementMap": "_673ZA",
  "container": "lHfak",
  "fullscreen": "wLdfy",
  "background_overlay": "UjPx2",
  "with_image": "mRLn2",
  "options": "v0e4x",
  "webview": "x4k1B",
  "grid": "_5xVdd",
  "option": "_7j5V-",
  "cta_button": "mJ7Sh",
  "add_option": "HN-0y",
  "see_more": "Z4-Mk",
  "list": "_8H48x",
  "column": "sVLLV",
  "additional_note": "EV0Pl",
  "spinner": "fNqmV",
  "spin": "LlAis",
  "shown": "Eig-C",
  "error": "_5IbMP"
};
export {
  poll_default as default
};
//# sourceMappingURL=poll-scss.js.map
